import { Link, createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

import { Alert, Card } from "../components/ui";
import { ResetPasswordForm } from "../features/auth/PasswordResetForms";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/reset-password")({
  validateSearch: z.object({ token: z.string().optional(), error: z.string().optional() }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const t = useT();
  const { token, error } = Route.useSearch();
  const [done, setDone] = useState(false);
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.reset.title")}>
        {done ? (
          <Alert kind="success">{t("auth.reset.done")}</Alert>
        ) : token && !error ? (
          <ResetPasswordForm
            token={token}
            onDone={() => {
              setDone(true);
            }}
          />
        ) : (
          <Alert kind="error">{t("auth.reset.error.invalidToken")}</Alert>
        )}
        <p className="mt-4 flex flex-col gap-1 text-sm">
          <Link to="/login">{t("nav.signIn")}</Link>
        </p>
      </Card>
    </main>
  );
}
